import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import DashboardCard from "./DashboardCard";
import RedFlagAlerts from "./RedFlagAlerts";
import CustomerTypeBreakdown from "./CustomerTypeBreakdown";
import VisitSuccessMetrics from "./VisitSuccessMetrics";
import RecentGymActivity from "./RecentGymActivity";
import { fetchClosureExpectedStatsData } from "../../../../redux/prospect-reducers/prospectSlice";
import "../../../../styles/lead-mangement/lms-closure-report.css";
import {
  PeopleIcon,
  Target,
  TrendingUp,
  AlertTriangle,
  FilterIcon,
} from "../../../../images/icons/icons";

const GSPD = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { closureExpectedStats, closureExpectedStatsLoading } = useSelector(
    (state) => state?.prospects
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const [activeSubTab, setActiveSubTab] = useState("recent_activity");
  const [showFilters, setShowFilters] = useState(false);
  const subTabs = [
    { id: "recent_activity", label: "RECENT ACTIVITY" },
    { id: "red_flag_alerts", label: "RED FLAG ALERTS" },
  ];

  const initialFilters = {
    gym_id: !isAdmin && !isMarketing && !isClusterManager ? userInfoData?.gym_id || "" : "",
  };
  const [filters, setFilters] = useState(initialFilters);

  // useEffect(() => {
  //   setFilters((prev) => ({
  //     ...prev,
  //     gym_id: userInfoData?.gym_id || "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    if (!userInfoData?.token) return;
    dispatch(
      fetchClosureExpectedStatsData({
        filters,
        token: userInfoData?.token,
      })
    );
  }, [dispatch, userInfoData?.token, filters]);

  // Build dashboard cards from API data
  const stats = closureExpectedStats?.data?.[0];
  const dashboardCards = stats
    ? [
        {
          title: "Total Gym Leads",
          value: stats?.total || "0",
          icon: PeopleIcon,
          subtitle: `FRESH : ${stats?.fresh_leads || 0} | RENEWAL : ${
            stats?.renewal_leads || 0
          } | UNPAID : ${stats?.unpaid || 0}`,
          background: "green",
        },
        {
          title: "Closure Expected",
          value: stats?.closure_expected_leads || "0",
          icon: Target,
          subtitle: "Critical Tracking Stage",
          background: "blue",
        },
        {
          title: "Visit-to-Close Rate",
          value: `${stats?.visit_to_close_rate || 0}%`,
          icon: TrendingUp,
          subtitle: "Visits Converted To Memberships",
          background: "orange",
        },
        {
          title: "Red Flag Alerts",
          value: stats?.red_flags || "0",
          icon: AlertTriangle,
          subtitle: "Requiring Immediate Attention",
          background: "red",
        },
      ]
    : [];

  return (
    <>
      {/* Overview Cards */}
      {closureExpectedStatsLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 160,
          }}
        >
          <ReactVortoxSpinner />
        </div>
      ) : (
        <div className="lms-closure-dashboard-cards">
          {dashboardCards?.map((card) => (
            <div key={card?.title}>
              <DashboardCard {...card} />
            </div>
          ))}
        </div>
      )}

      {/* Gym-Specific Pipeline Overview */}
      <div className="lms-closure-gyms-pipeline-overview">
        <CustomerTypeBreakdown stats={stats}  userInfoData={userInfoData} />
        <VisitSuccessMetrics userInfoData={userInfoData} />
      </div>

      <div className="lms-closure-sub-tab-and-filter-toggle-container">
        <div className="lms-closure-sub-tab">
          <div className="lms-closure-sub-tab-buttons">
            {subTabs.map((subTab) => (
              <button
                key={subTab.id}
                className={`lms-closure-sub-tab-button ${
                  activeSubTab === subTab.id
                    ? "lms-closure-sub-tab-button-active"
                    : ""
                }`}
                onClick={() => setActiveSubTab(subTab.id)}
              >
                {subTab.label}
              </button>
            ))}
          </div>
        </div>
        <div
          className="lms-closure-filter-toggle-btn"
          onClick={() => setShowFilters(!showFilters)}
          title={showFilters ? "Hide Filters" : "Show Filters"}
        >
          <FilterIcon />
          <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
        </div>
      </div>

      {/* Red Flag Alerts and Recent Activity Section */}
      <div className="lms-closure-red-flag-alerts-and-recent-activity-section">
        {activeSubTab === "red_flag_alerts" && (
          <RedFlagAlerts
            userInfoData={userInfoData}
            showFilters={showFilters}
          />
        )}
        {activeSubTab === "recent_activity" && (
          <RecentGymActivity
            userInfoData={userInfoData}
            showFilters={showFilters}
          />
        )}
      </div>
    </>
  );
};

export default GSPD;
